export default "dist/images/block-card-full.7d0f3d1.png";